import { Text, useColorModeValue } from '@chakra-ui/react';
import React from 'react';

import { colors } from 'packages/common-frontend/colors';

export const SectionHeader = ({ title }: { title: string }) => {
  const textColor = useColorModeValue(colors.black[95], colors.white[700]);
  return (
    <Text fontSize="16px" color={textColor} fontWeight={600}>
      {title}
    </Text>
  );
};
